import React, { FunctionComponent, useState, useEffect } from "react";

import InfiniteScroll from "react-infinite-scroll-component";

import { UserProfileNavItemProps } from "./UserProfile";

import { useApiService } from "../../hooks/useApiService";
import { useEffectOnMount } from "../../hooks/useEffectOnMount";

import ListContentLoader from "../../components/ListContentLoader";
import { App } from "../../domain/App";

import UserProfileItemLink from "./UserProfileItemLink";

const UserAppInstalls: FunctionComponent<UserProfileNavItemProps> = ({ userId, updateTotalCount, fixedScrollableContentHeight }) => {
  const appsPerPage = 20;

  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [apps, setApps] = useState<Pick<App, 'id' | 'name' | 'icon'>[]>([]);

  const [fetchApps, { isLoading: isFetchingApps }] = useApiService('user', userService => (
    (page) => (
      userService.fetchUserApps(userId, page, appsPerPage).then(appsPage => {
        const { data, pageCount, total } = appsPage;

        setApps([...apps, ...data.map(a => ({ id: a.id, name: a.name, icon: a.icon }))]);
        setPageCount(pageCount);

        updateTotalCount(total);
      })
    )
  ));

  const fetchNextPage = () => setPage(page + 1);

  useEffect(() => {
    page && fetchApps(page);
  // eslint-disable-next-line
  }, [page]);

  useEffectOnMount(fetchNextPage);

  const loader = <ListContentLoader />;

  return (
    <InfiniteScroll
      next={fetchNextPage}
      hasMore={page < pageCount}
      dataLength={apps.length}
      loader={loader}
      endMessage={isFetchingApps ? loader : (!apps.length && <p className="text-center">No apps found</p>)}
      height={fixedScrollableContentHeight}
    >
      {apps.map(app => (
        <UserProfileItemLink
          key={app.id}
          link={`/apps/update/${app.id}`}
          label={app.name}
          image={app.icon}
        />
      ))}
    </InfiniteScroll>
  );
};

export default UserAppInstalls;
